import SubmissionNoteService from '@/services/submission_note';

export default {
	namespaced: true,
	state: {
    submission_id: ''
	},

	getters: {
		async getSubmissionNoteBySubmissionId(state) {
			try {
				let response = await SubmissionNoteService.getSubmissionNoteBySubmissionId({
          submission_id: state.submission_id
        });
				return response.data ? response.data.attributes : []
			} catch (e) {
				console.log(e)
			}
		}
	},

	actions: {
    async createSubmissionNote({ commit, state, getters, dispatch }, payload) {
      try {
				const response = await SubmissionNoteService.createSubmissionNote({
          ...payload
        });
        return response;
			} catch (e) {
        console.log(e)
			}
    },
    async deleteSubmissionNote({ commit, state, getters, dispatch }, id) {
			try {
				await SubmissionNoteService.deleteSubmissionNote(id);
			} catch (e) {
        console.log(e)
			}
    },
	},

	mutations: {
		SET_SUBMISSION_ID(state, payload) {
			state.submission_id = payload;
		}
	}
};
